import { render } from "./bracket-elimination.vue?vue&type=template&id=2bfc4954"
import script from "./bracket-elimination.vue?vue&type=script&lang=js"
export * from "./bracket-elimination.vue?vue&type=script&lang=js"

import "./bracket-elimination.vue?vue&type=style&index=0&id=2bfc4954&lang=scss"

import exportComponent from "/usr/src/app/frontend_result/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__